import * as React from 'react';
import { useGetCordwoodHistoryQuery } from "../../../apis/CordwoodHistory.api";
import { PrimaryCordwoodHistory, CordwoodHistory } from "../../../types/models/CordwoodHistory";
import CordwoodName from "../../../../timber/components/cordwood/CordwoodDetail/CordwoodName";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: CordwoodHistory;
};

export const CordwoodHistoryNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<><CordwoodName id={ data?.cordwoodId }/>
                    {data?.action && <> | </> }{ data?.action }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const CordwoodHistoryName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetCordwoodHistoryQuery(PrimaryCordwoodHistory.fromId(id))
    return (<CordwoodHistoryNameDisplay data={data}/>)
}

export default CordwoodHistoryName;
